<script setup lang="ts">
import BPage from 'src/shared/components/base/BPage/BPage.vue';
import SchoolClassDetailView from 'src/modules/School/views/SchoolClassDetailView/SchoolClassDetailView.vue';
</script>

<template>
  <BPage>
    <SchoolClassDetailView />
  </BPage>
</template>
